import { useMemo, useState } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import { IOption } from '@user/components/Filters'
import { LeadType } from '@user/components/Leads/LeadFilters/typings'
import { containsField } from '@user/components/Settings/PendingLeadSettings/helpers'
import { getStyles } from '@user/components/Settings/PendingLeadSettings/styles'
import type { IAutoReviewAdditionalField } from '@user/store/autoReviewSettings'

type Props = {
  leadTypes: IOption[]
  visibleSelectedTypes: LeadType[]
  requiredAdditionalFields: IAutoReviewAdditionalField[]
  fieldOptions: IAutoReviewAdditionalField[]
}

export const useData = ({
  leadTypes,
  visibleSelectedTypes,
  requiredAdditionalFields,
  fieldOptions,
}: Props) => {
  const isMobile = useMediaQuery('(max-width:900px)')
  const styles = useMemo(() => getStyles(isMobile), [isMobile])
  const [dialogOpen, setDialogOpen] = useState(false)

  const leadTypeLabels = useMemo(
    () =>
      leadTypes
        .filter((option) =>
          visibleSelectedTypes.includes(String(option.value) as LeadType),
        )
        .map((option) => option.label),
    [leadTypes, visibleSelectedTypes],
  )

  const hasAdditionalFields = requiredAdditionalFields.length > 0

  const addFieldDisabled = useMemo(
    () =>
      fieldOptions.length === 0 ||
      fieldOptions.every((option) =>
        containsField(requiredAdditionalFields, option),
      ),
    [fieldOptions, requiredAdditionalFields],
  )

  return {
    styles,
    dialogOpen,
    setDialogOpen,
    leadTypeLabels,
    hasAdditionalFields,
    addFieldDisabled,
  }
}

export type UseData = ReturnType<typeof useData>
